/** What a view that crashed shows instead of the framework's error screen: a way back, never a dead end. */
import { useRouteError } from 'react-router';

export function ErrorPage() {
  const error = useRouteError();
  const detail = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  return (
    <div className="min-h-screen bg-n1 text-n10 font-sans grid place-items-center p-6">
      <div className="max-w-md flex flex-col gap-4">
        <h1 className="m-0 text-title font-semibold">This view could not be shown</h1>
        <p className="m-0 text-body text-n8">
          Something unexpected happened while drawing this page. Nothing was changed. You can go back to where you were or start from the front page.
        </p>
        {detail && <p className="m-0 font-mono text-micro text-n7 [overflow-wrap:anywhere]">{detail}</p>}
        <div className="flex gap-3">
          <button type="button" onClick={() => window.history.back()}
            className="h-10 px-4 rounded-full border-0 bg-n10 text-n1 text-small font-medium cursor-pointer">Go back</button>
          <a href="/" className="h-10 px-4 inline-flex items-center rounded-full bg-n3 text-n10 text-small font-medium no-underline">Front page</a>
        </div>
      </div>
    </div>
  );
}
